// Общий шаг ввода времени компании (company.hr_timeStepMinutes).
// Устанавливается в App при загрузке /user; используется таймшит-пикерами и модалками отпуска.
let cached = 15;

export const setCompanyTimeStep = (v?: number | null) => { cached = v && v > 0 ? v : 15; };
export const getCompanyTimeStep = () => cached;
